import { FaceLandmarker, FilesetResolver } from '@mediapipe/tasks-vision';

export default async function runLandmarksStream(video, onResults) {
  const vision = await FilesetResolver.forVisionTasks(
    'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision/wasm'
  );

    const faceLandmarker = await FaceLandmarker.createFromOptions(
      vision,
      {
        baseOptions: {
          modelAssetPath:
            'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task',
        },
        numFaces: 1,
        runningMode: 'VIDEO',
        outputFaceBlendshapes: true
      }
    );

  let animationId;

  const loop = () => {
    if (
      !video ||
      video.readyState < 2 ||
      video.videoWidth === 0 ||
      video.videoHeight === 0
    ) {
      animationId = requestAnimationFrame(loop);
      return;
    }

    const now = performance.now();
    const results = faceLandmarker.detectForVideo(video, now);

    if (results) {
      onResults(results);
    }

    animationId = requestAnimationFrame(loop);
  };

  loop();

  return () => {
    cancelAnimationFrame(animationId);
    faceLandmarker.close();
  };
}